import { Mode } from '@/model';

export class ReadonlyMode extends Mode {}
